<template>
  <div class="fixed-bottom-row-wrapper">
    <div
      v-if="columnPositionNum.left > 0"
      class="fixed-bottom-row-fixed fixed-bottom-row-fixed--left"
      :style="{
        width: `${layout.leftFixedTableWidth}px`,
        bottom: `${layout.gutterHeight}px`
      }"
    >
      <table
        class="fixed-bottom-table"
        cellspacing="0"
        cellpadding="0"
        border="0"
      >
        <colgroup>
          <col :width="width" v-for="width in fixedLeftTableColWidths" />
        </colgroup>
        <tbody>
        <tr
          :class="{'has-gutter': layout.gutterWidth}"
          v-for="(row, idx) in tableData.fixedBottom"
          :style="{
            height: layout.fixedBottomTableRowHeights[idx]
          }"
          :key="row.label"
        >
          <td v-if="hasSelectionColumn && selectionColumnFixed">
            <template>{{row.label}}</template>
          </td>
          <td v-if="hasIndexColumn && indexColumnFixed">
            <template v-if="!hasSelectionColumn">{{row.label}}</template>
          </td>
          <td v-if="hasExpand && expandFixed">
            <template v-if="!hasIndexColumn && !hasSelectionColumn">{{row.label}}</template>
          </td>
          <td
            v-for="({prop, label, fixed, align}, idx) in visibleTableHead"
            :key="prop"
            :class="[align && `is-${align}`]"
            v-if="(fixed === true || fixed === 'left')"
          >
            <div class="cell">
              <template v-if="!hasIndexColumn && !hasExpand && !hasSelectionColumn && idx === 0">{{row.label}}</template>
              <slot :name="prop" :value="row.data[prop]" v-else-if="$scopedSlots[prop]"></slot>
              <template v-else>{{row.data[prop]}}</template>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <!--<div-->
        <!--class="fixed-bottom-name-group"-->
        <!--:style="{width: `${layout.fixedNameGroupWidth - 1}px`}"-->
      <!--&gt;-->
        <!--<div-->
          <!--class="fixed-bottom-name"-->
          <!--v-for="(row, idx) in tableData.fixedBottom"-->
          <!--:key="row.label"-->
          <!--:style="{-->
            <!--height: layout.fixedBottomTableRowHeights[idx]-->
          <!--}"-->
        <!--&gt;-->
          <!--{{row.label}}-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <div
      v-if="hasFixedRight"
      class="fixed-bottom-row-fixed fixed-bottom-row-fixed--right"
      :style="{
        width: `${layout.rightFixedTableWidth}px`,
        bottom: `${layout.gutterHeight}px`
      }"
    >
      <table
        class="fixed-bottom-table"
        cellspacing="0"
        cellpadding="0"
        border="0"
      >
        <colgroup>
          <col :width="width" v-for="(width, idx) in fixedRightTableColWidths"/>
        </colgroup>
        <tbody>
        <tr
          :class="{'has-gutter': layout.gutterWidth}"
          v-for="(row, idx) in tableData.fixedBottom"
          :key="row.label"
          :style="{
            height: layout.fixedBottomTableRowHeights[idx]
          }"
        >
          <td
            v-for="({prop, label, fixed, align}) in visibleTableHead"
            :key="prop"
            :class="[align && `is-${align}`]"
            v-if="fixed === 'right'"
          >
            <div class="cell">
              <slot :name="prop" :value="row.data[prop]" v-if="$scopedSlots[prop]"></slot>
              <template v-else>{{row.data[prop]}}</template>
            </div>
          </td>
          <td v-if="hasEditColumn"></td>
          <td class="gutter" :width="`${layout.gutterWidth}px`" v-show="layout.gutterWidth"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="fixed-bottom-row" ref="fixedRow">
      <table
        class="fixed-bottom-table"
        cellspacing="0"
        cellpadding="0"
        border="0"
        ref="fixedBottomTable"
      >
        <colgroup>
          <col :width="width" v-for="width in layout.colsWidth" />
        </colgroup>
        <tbody>
        <tr
          :class="{'has-gutter': layout.gutterWidth}"
          v-for="row in tableData.fixedBottom"
          :key="row.label"
        >
          <td v-if="hasSelectionColumn">
            <template>{{row.label}}</template>
          </td>
          <td v-if="hasIndexColumn">
            <template v-if="!hasSelectionColumn">{{row.label}}</template>
          </td>
          <td v-if="hasExpand">
            <template v-if="!hasIndexColumn && !hasSelectionColumn">{{row.label}}</template>
          </td>
          <td
            v-for="({prop, label, fixed, align}, idx) in visibleTableHead"
            :class="[align && `is-${align}`]"
            :key="prop"
          >
            <div class="cell">
              <template v-if="!hasIndexColumn && !hasExpand && !hasSelectionColumn && idx === 0">{{row.label}}</template>
              <slot :name="prop" :label="row.label" :value="row.data[prop]" v-else-if="$scopedSlots[prop]"></slot>
              <template v-else>{{row.data[prop]}}</template>
            </div>
          </td>
          <td v-if="hasEditColumn"></td>
          <td class="gutter" :width="`${layout.gutterWidth}px`" v-show="layout.gutterWidth"></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import TableFixedBottomLayout from './table-fixed-bottom-layout'

  import {
    getEmptyObject
  } from "../../../../utils";

  export default {
    props: {
      hasIndexColumn: Boolean,
      hasSelectionColumn: Boolean,
      hasExpand: Boolean,
      hasEditColumn: Boolean,
      selectionColumnFixed: Boolean,
      expandFixed: Boolean,
      indexColumnFixed: Boolean,
      tableData: {
        type: Object,
        default: getEmptyObject
      },
      tableHead: {
        type: Array,
        default: []
      },
      filterRes: {
        type: Array,
        default: []
      }
    },
    data () {
      const layout = new TableFixedBottomLayout()

      return {
        layout,
        isInit: false
      }
    },
    methods: {
      init (tableRef) {
        const {
          fixedRow
        } = this.$refs

        const {
          headerWrapper,
          bodyWrapper
        } = tableRef.$refs

        const tableFixedBottom = this

        this.updateFixedTables(tableRef)

        let fixedNameGroupWidth

        if(this.hasIndexColumn && this.hasSelectionColumn){
          fixedNameGroupWidth = parseInt(this.layout.colsWidth[0]) + parseInt(this.layout.colsWidth[1])
        }else{
          fixedNameGroupWidth = this.layout.colsWidth[0]
        }

        this.layout.updateLayout({
          fixedNameGroupWidth
        })

        fixedRow.addEventListener('scroll', function () {
          bodyWrapper.scrollLeft = this.scrollLeft

          const maxScrollLeftPosition = this.scrollWidth - this.offsetWidth - 1
          let scrollPosition
          const scrollLeft = this.scrollLeft
          if (scrollLeft >= maxScrollLeftPosition) {
            scrollPosition = 'right'
          } else if (scrollLeft === 0) {
            scrollPosition = 'left'
          } else {
            scrollPosition = 'middle'
          }
          tableFixedBottom.$emit('scrolling', scrollPosition)
          tableFixedBottom.layout.fixedRowScrollLeft = this.scrollLeft
        }, false)

        bodyWrapper.addEventListener('scroll', function () {
          if(tableFixedBottom.layout.fixedRowScrollLeft !== this.scrollLeft) {
            tableFixedBottom.layout.fixedRowScrollLeft = fixedRow.scrollLeft = this.scrollLeft
          }
        }, false)

        this.$nextTick(() => {
          this.layout.gutterHeight = fixedRow.offsetHeight - fixedRow.clientHeight
        })

        this.isInit = true
      },
      updateFixedTables (tableRef) {
        const {
          fixedBottomTable,
          fixedRow
        } = this.$refs

        const {
          headerWrapper,
          rightFixedBodyWrapper
        } = tableRef.$refs

        const tableWidth = window.getComputedStyle(headerWrapper.querySelector('table')).width

        const colsWidth = Array.from(headerWrapper.querySelectorAll('col'), col => col.width)
        const gutter = headerWrapper.querySelector('.gutter')
        const gutterWidth = gutter ? parseInt(headerWrapper.querySelector('.gutter').style.width) : 0
        const rightFixedTableWidth = tableRef.layout.rightFixedWidth + gutterWidth
        const leftFixedTableWidth = tableRef.layout.fixedWidth + 1

        this.layout.updateLayout({
          tableWidth,
          colsWidth,
          gutterWidth,
          rightFixedTableWidth,
          leftFixedTableWidth
        })

        this.$nextTick(() => {
          this.layout.gutterHeight = fixedRow.offsetHeight - fixedRow.clientHeight
          this.layout.fixedRowScrollWidth = fixedRow.scrollWidth
          this.layout.fixedBottomTableRowHeights = Array.from(fixedBottomTable.querySelectorAll('tr'), tr => window.getComputedStyle(tr).height)
        })
      }
    },
    watch: {
      'layout.tableWidth' (newWidth) {
        this.$refs.fixedBottomTable.style.width = newWidth
      }
    },
    computed: {
      fixedRightTableColWidths () {
        const {
          colsWidth
        } = this.layout

        const notFixedRightColumnNum = this.columnPositionNum.left + this.columnPositionNum.none

        return colsWidth.slice(notFixedRightColumnNum + this.othersFixedLeftColumnNum, colsWidth.length)
      },
      fixedLeftTableColWidths () {
        const {
          colsWidth
        } = this.layout

        return colsWidth.slice(0, this.columnPositionNum.left + this.othersFixedLeftColumnNum)
      },
      visibleTableHead () {
        return this.tableHead.filter(({label}) => this.filterRes.includes(label))
      },
      columnPositionNum () {
        let fixedColumnData = {
          left: 0,
          none: 0,
          right: 0
        }

        this.visibleTableHead.forEach(({fixed, label}) => {
          if(fixed === true || fixed === 'left'){
            fixedColumnData.left++
          }else if(fixed === 'right'){
            fixedColumnData.right++
          }else{
            fixedColumnData.none++
          }
        })

        if (this.hasIndexColumn && this.indexColumnFixed) {
          fixedColumnData.left++
        }

        if (this.hasSelectionColumn && this.selectionColumnFixed) {
          fixedColumnData.left++
        }

        if (this.hasExpand && this.expandFixed) {
          fixedColumnData.left++
        }

        return fixedColumnData
      },
      othersFixedLeftColumnNum () {
        return [this.hasIndexColumn, this.hasSelectionColumn, this.hasExpand].filter(result => result).length
      },
      hasFixedRight () {
        return this.layout.colsWidth.length !== this.notFixedRightColumnNum
      }
    }
  }
</script>
